var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h2', [_vm._v("安全设置")]), _c('a-divider'), _c('a-form', {
    attrs: {
      "layout": "vertical",
      "form": _vm.form
    }
  }, [_c('a-form-item', {
    attrs: {
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol,
      "label": "旧密码"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['oldpassword', _vm.validatorRules.oldpassword],
      expression: "['oldpassword', validatorRules.oldpassword]"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入旧密码"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol,
      "label": "新密码"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['password', _vm.validatorRules.password],
      expression: "['password', validatorRules.password]"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol,
      "label": "确认新密码"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['confirmpassword', _vm.validatorRules.confirmpassword],
      expression: "['confirmpassword', validatorRules.confirmpassword]"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请确认新密码"
    },
    on: {
      "blur": _vm.handleConfirmBlur
    }
  })], 1), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v("修改密码")])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };